<template lang="pug">
	.creative--templates.flex-row.space.wrap
		Popup(
			v-if="templatesPopupVisible",
			:popupVisible="templatesPopupVisible",
			:width="640", :height="720",
			:closeOnOutsideClick="true",
			@hiding="templatesPopupVisible = false"
		)
			.creative--templates
				ListView.full-width(
					ref="templates",
					:topPagerVisible="false",
					:showColumnHeaders="false",
					:filterRow="false",
					initialView="table",
					:columns="columns",
					width="100%", :height="565",
					:searchVisible="false",
					:hideViewsSelection="true",
					:getTotal="(r) => r.TotalNumberOfRecords",
					:getItems="(r) => prepareData(r.Results)",
					:getData="getData",
					noDataText=" "
				)
					.flex-row.space.align-center(slot="left-actions")
						.font-big.upper.grey {{selectOnlyMyTemplates ? $tCaption('My templates') : $tCaption('Templates store')}}
					.flex-row.space.align-center(slot="right-actions")
						Dropdown.small(:getData="$Data.getTemplateCategories", :getTotal="(r) => r.TotalNumberOfRecords", :getItems="(r) => r.Results", :columns="[{ dataField: 'Name', caption: $tCaption('Category') }]",
							displayExpr="Name",
							valueExpr="Oid",
							:placeholder="$tCaption('Category')",
							:showColumnHeaders="false",
							:filtersVisible="false",
							:selectedItems="filteredCategories.map(f => f.Oid)",
							:searchVisible="false",
							:multiple="true",
							:width="120"
							@select-data="v => filteredCategories = v || []")
						Dropdown.small(:getData="(a,b,c) => $Data.getUsedLanguages(a,b,c,true)", :getTotal="(r) => r.TotalNumberOfRecords", :getItems="(r) => r.Results", :columns="[{ dataField: 'Name', caption: $tCaption('Language') }]",
							displayExpr="Name",
							valueExpr="Code",
							:placeholder="$tCaption('Language')",
							:showColumnHeaders="false",
							:filtersVisible="false",
							:selectedItems="filteredLanguages.map(f => f.Code)",
							:searchVisible="true",
							:multiple="true",
							:width="120"
							@select-data="v => filteredLanguages = v || []")
					template(v-slot:displayValue="{ data }")
						.flex-row.space-medium.creative--templates
							template(v-if="data.ImageUrl")
								img.thumb-image(:src="data.ImageUrl")
							.flex-col.space.grey.creative-template.flex-1.wrap.space-between
								.flex-row.space.align-center
									.play-button-handler.flex-col.center.align-center
										a.play-button(@click="playAudio(data)", :class="{ disabled: !data.FinalAudioUrl }")
											fas(:icon="isAudioLoading === data.Oid ? 'spinner' : (isPlaying === data.Oid ? 'stop' : 'play')", :spin="isAudioLoading === data.Oid")
									.flex-col
										.flex-row.flex-1.space.align-center
											.flex-row.template-title.space.align-center
												a.flex-row.space.align-center.font-big(
													v-if="data.IsPurchased || !data.IsProduct",
													@click="e => editTemplate(data, e.ctrlKey)",
													:title="$tCaption('Edit template')"
												)
													span {{data.RootCreativeName}}
													fas(icon="pen-square")
												.name.text-overflow.font-big(v-else)
													span {{data.RootCreativeName}}
												.free-price.flex-row.align-center.center.space-small(v-if="!data.Price && !data.IsPurchased")
													fas(icon="check")
													span {{$tCaption('Free')}}
											a.delete-button.font-big(
												v-if="!data.IsPurchased && !data.IsProduct",
												@click="deleteTemplate(data.Oid)",
												:title="$tCaption('Delete template')"
											)
												fas(icon="trash-alt", size="sm")
										template(v-if="!selectOnlyMyTemplates")
											.flex-row.space(v-if="!data.IsPurchased")
												template(v-if="data.Price")
													.price {{$Data.formatNumber(data.Price, 'fixedPoint')}}
													.currency {{data.CurrencyCode}}
											.font-small.upper(v-else) {{$tCaption('Purchased')}}
										.flex-row.space.max-width-250
											.duration.font-tiny.nowrap(v-if="data.Length || data.Duration") {{getDuration(data.Length || data.Duration / 1000)}} {{$tCaption('sec.')}},
											.language.font-tiny.nowrap.text-overflow(v-if="data.LanguageName") {{data.LanguageName}}
										.flex-row.space.max-width-250
											.font-tiny.nowrap(v-if="data.TemplateCategory") {{data.TemplateCategory.Name}}
								.flex-row(v-if="!data.IsUsedServicesAlive || data.TemplateStatus")
									.is-unavailable.upper.flex-row.space(:title="$tCaption('Template unavailable at current moment')")
										fas(icon="link-slash")
										span {{$tCaption('Unavailable')}}
								.description.font-small {{data.Description}}
								.flex-row.justify
									.left
									.right.flex-row
										template(v-if="data.IsProduct")
											Loader(v-if="buyingTemplateId === data.Oid", text="")
											DxButton(
												v-else-if="!data.IsPurchased",
												:text="$tCaption('Buy')",
												type="success",
												icon="fas fa-shopping-cart",
												:disabled="buyingTemplateInProgress",
												@click="buyTemplate(data)"
											)
							.flex-row.align-center(v-if="!data.IsProduct")
								.flex-col.align-center.center.add-creative-button.space(@click="initCreative(data)")
									Loader(v-if="initializingTemplateId === data.Oid", text="")
									template(v-else)
										fas(icon="plus" size="lg")
										.text.upper {{$tCaption('Add creative')}}
				.center-fixed.flex-col.space-large.center.align-center(v-if="hasOwnItems === false && selectOnlyMyTemplates === true && !isLoading")
					fas(icon="shopping-cart", size="7x")
					.font-big.grey(v-if="hasFilters") {{$tCaption('No items found.')}}
					.font-big.grey(v-else) {{$tCaption('Your template library is empty.')}}
					DxButton(:text="$tCaption('Templates store')", @click="selectOnlyMyTemplates = false", icon="fas fa-arrow-right")
			template(slot="actions-left")
				DxButton(
					v-if="hasOwnItems === true && selectOnlyMyTemplates",
					type="success",
					:text="$tCaption('Templates store')",
					@click="selectOnlyMyTemplates = false",
					icon="fas fa-shopping-cart"
				)
				DxButton(
					v-if="!selectOnlyMyTemplates",
					:text="$tCaption('Back to my templates')",
					icon="fas fa-chevron-left"
					@click="hasOwnItems = null; selectOnlyMyTemplates = true"
				)
			template(slot="actions-right")
				DxButton(
					v-if="canCreateCreativeTemplate && selectOnlyMyTemplates",
					icon="fas fa-plus"
					:text="$tCaption('Create Template')"
					type="default"
					@click="showCreateTemplatePopup()"
				)
				DxButton(:text="$tCaption('Close', '@actions')", icon="close", @click="templatesPopupVisible = false")
		Popup(
			v-if="templateFieldsPopupVisible",
			:popupVisible="templateFieldsPopupVisible",
			:title="$tCaption('New creative')"
			:width="480", :height="420",
			:closeOnOutsideClick="true",
			:autosize="true",
			@hiding="templateFieldsPopupHiding"
		)
			.creative--templates
				CreativeTemplatesNewCreative(:templateFields="templateFields", :name.sync="newCreativeName", :template="initializingTemplate", @newsML="v => newsML = v")
			template(slot="actions-left")
				DxCheckBox(v-if="initializingTemplate && initializingTemplate.HasSchedule", :value.sync="autoStartPublish", :text="$tCaption('Auto-start publish')")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="templateFieldsPopupHiding")
				DxButton(:text="$tCaption('Create', '@actions')", type="success", @click="createCreative")
		Popup(
			:popupVisible="templatePopupVisible",
			:title="$tCaption('Create template')"
			:width="720", :height="720",
			:closeOnOutsideClick="false",
			@hiding="hidingTemplatePopupVisible()"
		)
			CreativeDetail(
				:editingCreative="newTemplate",
				:isLoading="isLoading",
				:newCreateTemplate="true",
			)
			template(slot="actions-right")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="hidingTemplatePopupVisible")
				DxButton(:text="$tCaption('Create', '@actions')", type="success", @click="createTemplate")
		CompanyInfoChecker(ref="companyInfoChecker")
</template>

<script>
	import _ from 'lodash';
	import auth from 'auth';
	import ListView from 'app-core/ListView.vue';
	import DxButton from 'devextreme-vue/button';
	import DxTextBox from 'devextreme-vue/text-box';
	import Dropdown from 'app-core/Dropdown.vue';
	import Popup from 'app-core/Popup.vue';
	import Loader from 'app-core/Loader.vue';
	import DxValidator, { DxRequiredRule } from 'devextreme-vue/validator';
	import notify from "devextreme/ui/notify";
	import CreativeDetail from 'view/creative/CreativeDetail.vue';
	import CreativeTemplatesNewCreative from './CreativeTemplatesNewCreative.vue';
	import CompanyInfoChecker from 'view/company/CompanyInfoChecker.vue';
	import DxCheckBox from 'devextreme-vue/check-box';

	export default {
		translationCategory: 'creative.CreativeTemplates',
		name: 'creative--templates',
		components: {
			ListView,
			DxButton,
			DxTextBox,
			Popup,
			Loader,
			DxValidator,
			DxRequiredRule,
			CreativeDetail,
			CreativeTemplatesNewCreative,
			CompanyInfoChecker,
			Dropdown,
			DxCheckBox
		},
		props: ['folderId'],
		data() {
			return {
				templatesPopupVisible: false,
				columns: [{ dataField: 'RootCreativeName', cellTemplate: 'displayValue' }],
				isLoading: 0,
				buyingTemplateId: null,
				initializingTemplateId: null,
				initializingTemplate: null,
				isAudioLoading: false,
				isPlaying: false,
				player: null,
				selectOnlyMyTemplates: true,
				hasOwnItems: null,
				templateFields: [],
				templateFieldsPopupVisible: false,
				newCreativeName: this.$tCaption('New creative'),
				templatePopupVisible: false,
				defaultTemplate: {
					IsProduct: false,
					IsTemplate: true,
					Name: 'New creative template',
					JsonConfig: {
						templateFields: [],
						adjustLengthToTemplate: false
					},
					Description: null,
					ImageUrl: null,
					LanguageCode: null,
					Price: null,
					CurrencyCode: null,
					IsNewsMLTemplate: false,
				},
				newTemplate: null,
				buyingTemplateInProgress: false,
				filteredLanguages: [],
				filteredCategories: [],
				newsML: null,
				autoStartPublish: false
			}
		},
		computed: {
			canCreateCreativeTemplate() {
				return auth.canCreateCreativeTemplate();
			},
			hasFilters() {
				return this.filteredLanguages.length + this.filteredCategories.length;
			}
		},
		watch: {
			templatesPopupVisible(v) {
				if (!v) {
					this.$refs.listView?.reload();
				}
			},
			selectOnlyMyTemplates() {
				this.$refs.templates?.reload({ clear: true });
			},
			filteredLanguages() {
				this.$reloadTemplatesStore();
			},
			filteredCategories() {
				this.$reloadTemplatesStore();
			}
		},
		mounted() {
			if (__DEBUG__)
				window.creativeTemplates = this;

			this.$eventsBus.$on('signalr-on-notification', this.signalrOnNotification);

			this.$reloadTemplatesStore = _.debounce(this.reloadTemplatesStore, 1000, {
				'leading': false,
				'trailing': true
			})
		},		
		destroyed() {
			this.$eventsBus.$off('signalr-on-notification', this.signalrOnNotification);
			delete this.$reloadTemplatesStore;
		},
		methods: {
			getDuration(dur) {
				return parseInt(dur);
			},
			reloadTemplatesStore() {
				this.$refs.templates.reload();
			},
			signalrOnNotification({ eventName, data }) {
				if (eventName === 'InvoiceStatusChanged') {
					this.gotoMyTemplates();
				}
			},
			gotoMyTemplates() {
				this.hasOwnItems = null;
				this.selectOnlyMyTemplates = true;
				this.$refs.templates.reload();
			},
			getData(pageIndex, limit, opts) {
				this.isLoading++;
				const filters =  [];

				if (this.filteredLanguages.length) {
					const filteredLanguagesFilter = [];
					this.filteredLanguages.map((f, i) => {
						if (i > 0) {
							filteredLanguagesFilter.push('or');
						}
						filteredLanguagesFilter.push(['LanguageCode', '=', f.Code]);
					});
					if (filters.length) filters.push('and');
					filters.push(filteredLanguagesFilter);
				}

				if (this.filteredCategories.length) {
					const filteredCategoriesFilter = [];
					this.filteredCategories.map((f, i) => {
						if (i > 0) {
							filteredCategoriesFilter.push('or');
						}
						filteredCategoriesFilter.push(['TemplateCategory.Oid', '=', f.Oid]);
					});
					if (filters.length) filters.push('and');
					filters.push(filteredCategoriesFilter);
				}
				
				const filterCriteria = filters.length ? `&filterCriteria=${encodeURIComponent(JSON.stringify(filters))}` : '';
				if (__DEBUG__)
					console.debug('Get data', { filters });
				return this.$Data
					.getExternalApi(
						'Creative/GetCreativeTemplates',
						`selectOnlyMyTemplates=${this.selectOnlyMyTemplates}&page=${pageIndex+1}${filterCriteria}`, limit)
					.then(r => {
						this.hasOwnItems = !!r.Results?.length;
						return r;
					})
					.finally(() => this.isLoading--);
			},
			prepareData(data) {
				return data.map(f => ({
					...f,
					LanguageName: this.$Data.getLanguageNameByCode(f.LanguageCode)
				}))
			},
			playAudio(template) {
				if (this.isAudioLoading) return;

				let hasBeenPlaying = this.isPlaying;
				this.stopAudio();

				if (hasBeenPlaying) return;

				this.player = new Audio();
				try {
					this.player.src = `${template.FinalAudioUrl}`;
					this.player.play();
					this.isPlaying = template.Oid;
					this.isAudioLoading = template.Oid;
					this.player.addEventListener('canplaythrough', () => this.isAudioLoading = false, false);
					this.player.addEventListener('ended', () => this.isPlaying = null, false);
				} catch {
					this.isAudioLoading = null;
					this.isPlaying = null;
				}
			},
			stopAudio() {
				if (this.player) {
					this.player.pause();
				}
				this.isPlaying = null;
			},
			showPopup() {
				this.templatesPopupVisible = false;
				this.selectOnlyMyTemplates = true;
				setImmediate(() => this.templatesPopupVisible = true);
			},
			async initCreative(template) {
				await this.$refs.companyInfoChecker.checkTimeZones();

				this.newCreativeName = this.$tCaption('New creative');
				this.initializingTemplateId = template.Oid;

				return this.$Data
					.getExternalApi(
						'Creative/GetCreative',
						`creativeId=${template.Oid}`
					)
					.then((templateItem) => {
						this.templateFields = templateItem.JsonConfig?.templateFields || [];
						this.initializingTemplate = templateItem;
						templateItem.HasSchedule = template.HasSchedule;

						if (this.templateFields.length || this.initializingTemplate?.IsNewsMLTemplate) {
							this.newsML = null;
							this.templateFieldsPopupVisible = false;
							setImmediate(() => {
								this.templateFieldsPopupVisible = true;
								this.autoStartPublish = false;
							});
						} else {
							this.createCreative();
						}
					});
			},
			async createCreative() {
				this.templateFieldsPopupVisible = false;
				this.$notifyMessage(this.$tCaption('Started generating creative "<NAME>"').replace('<NAME>', this.newCreativeName), { busy: true, type: 'warning' });
				const newsML = this.newsML ? {
					TopHeadline: this.newsML?.topHeadline,
					TopContent: this.newsML?.topContent,
					ZipUrl: this.newsML?.url,
					ZipData: {
						FileName: "newsml.zip",
						Base64Content: this.newsML?.file && this.$Data.splitDataUri(await this.$Data.blob2Base64(this.newsML.file))?.base64
					}
				} : null;
				
				let createCreativeFromTemplatePayload = {
					TemplateId: this.initializingTemplateId,
					CreativeName: this.newCreativeName,
					TemplateFields: this.templateFields.map(f => this.$Data.formatObjectToUpperCase(f)),
					AdjustLengthToTemplate: this.initializingTemplate?.JsonConfig?.adjustLengthToTemplate !== false,
					FolderId: this.folderId,
					NewsML: newsML
				};

				if (this.autoStartPublish) {
					createCreativeFromTemplatePayload.StartSchedule = true;
				}

				return this.$Data
					.postExternalApi('Creative/CreateCreativeFromTemplate', createCreativeFromTemplatePayload)
					.then((r) => {
						if (__DEBUG__)
							console.debug('CreateCreativeFromTemplate', { r });

						if (r.Success !== true) {
							this.$notifyError(`${this.$tCaption('Error while generating from template')}: ${r.ErrorMessage || ''}`);
						}

						this.templatesPopupVisible = false;
					})
					.finally(() => {
						this.initializingTemplateId = null;
						this.initializingTemplate = null;
					});
			},
			templateFieldsPopupHiding() {
				this.templateFieldsPopupVisible = false;
				this.initializingTemplateId = null;
				this.initializingTemplate = null;
			},
			buyTemplate(template) {
				const finish = () => {
					this.buyingTemplateId = null;
					this.buyingTemplateInProgress = false;
				}
				this.buyingTemplateInProgress = true;
				this.$confirmMessage({
					title: this.$tCaption('Confirm action', '@actions'),
					text: this.$tCaption('The item "<NAME>" will be added to your account. Would you like to proceed to checkout?').replace('<NAME>', template.RootCreativeName),
					handler: () => {
						this.buyingTemplateId = template.Oid;
						this.$Data.postExternalApi(
								'CustomerInvoice/CreateInvoice',
								[{
									ProductId: template.Oid,
									Type: this.$Data.objectTypes.CreativeTemplate
								}])
							.then(({Data}) => {
								const isPurchasesActivated = Data?.IsPurchasesActivated != null ? Data?.IsPurchasesActivated : [1,2,3].indexOf(Data.ProductsActivationStatus) > -1;
								if (Data.ProductsActivationStatus === 4) {
									this.$notifyError(this.$tCaption('Some error has been occured while processing.'));
									return;
								}
								if (isPurchasesActivated) {
									const mustBePaid = template.Price > 0 ? this.$tCaption('The invoice #"<InvoiceNumber>" must be paid within "<PaymentDays>" days.') : '';
									this.$notifySuccess(
										(this.$tCaption(`The "<TemplateName>" template has been successfully added to your account. `) + mustBePaid)
											.replace('<TemplateName>', template.RootCreativeName)
											.replace('<InvoiceNumber>', Data.InvoiceNumber)
											.replace('<PaymentDays>', Data.PaymentDays));
									finish();
								} else {
									this.$notifySuccess(this.$tCaption('An invoice has been created. The purchased template will be available after payment of the invoice.'));
									if (this.$auth.hasAccessToCompanyProfile()) {
										this.$router.push({ name: 'company-profile', params: { activeTab: 'invoices' } });
									} else {
										finish();
									}
								}
							});
					},
					cancel: finish
				});
			},
			createTemplate(e) {
				if (__DEBUG__)
					console.debug('Create template', { e });
				if (e?.validationGroup && !e.validationGroup.validate().isValid) {
					return;
				}
				this.$Data
					.createUpdateCreative(this.newTemplate)
					.then((r) => {
						this.hidingTemplatePopupVisible();
						if (__DEBUG__) console.log('Create template result', { r });
						if (r.Success) this.$refs.templates?.reload();
						else this.$notifyError(r.ErrorMessage);
					});
			},
			editTemplate(template, separateWindow) {
				let route = { path: `/creative/Detail/${template.Oid}` };
				if (separateWindow) {
					let routeData = this.$router.resolve(route);
					window.open(routeData.href, '_blank');
				} else {
					this.$router.push(route);
				}
			},
			deleteTemplate(id) {
				this.$confirmMessage({
					title: this.$tCaption('Confirm action', '@actions'),
					text: this.$tCaption('Are you sure you want to delete the current template?'),
					handler: () => {
						this.$Data
							.getExternalApi('Creative/DeleteCreative', `creativeId=${id}`)
							.then(() => {
								notify(this.$tCaption('Template deleted'), 'success', 600);
								this.$refs.templates?.reload();
							});
					}
				});
			},
			showCreateTemplatePopup() {
				this.newTemplate = { ...this.defaultTemplate };
				this.$nextTick(()=> {
					this.templatePopupVisible = true;
				});
			},
			hidingTemplatePopupVisible() {
				this.templatePopupVisible = false;
				this.newTemplate = null;
			}
		}
	};
</script>

<style lang="scss">
	@import "main/themes/generated/variables.base.scss";

	.creative--templates {
		.name {
			max-width: 400px;
		}

		.thumb-image {
			width: 100px;
			height: 100px;
			border-radius: 8px;
			background: rgba(0, 0, 0, 0.03);
			overflow: hidden;
			border: 1px solid rgba(0, 0, 0, 0.01);
			box-shadow: 0 1px 3px rgb(0 0 0 / 5%);
		}

		.play-button {
			color: #777;
			padding: 4px;
			transform: scale(1);
			transition: 0.2s;

			&.disabled {
				opacity: 0.3;
				pointer-events: none;
			}

			&:hover:not(.disabled) {
				color: $base-accent;
				transform: scale(1.3);
			}
		}

		.center-fixed {
			position: absolute;
			height: auto;
			width: 100%;
			left: 0px;
			top: 50%;
			transform: translateY(-50%);
		}

		.play-button-handler {
			border-radius: 100px;
			border: 1px solid #ededed;
			min-width: 30px;
			min-height: 30px;
			padding-top: 2px;

			svg[data-icon=play] {
				padding-left: 2px;
			}
		}

		.delete-button {
			color: #d90000;
		}

		.add-creative-button {
			width: 90px;
			height: 90px;
			background: rgb(239, 241, 243);
			border-radius: 4px;
			color: #555;
			cursor: pointer;
			transition: 0.3s;

			.text {
				font-size: 10px;
			}

			&:hover {
				background: $base-accent;
				color: $base-bg;
			}
		}

		td.dx-last-data-cell {
			background: #f7f7f7;
		}

		td.dx-last-data-cell {
			border-bottom: none;
		}

		.free-price {
			right: 0px;
			top: 0px;
			padding: 0px 5px;
			background: rgb(255 58 54);
			border-radius: 4px;
			font-size: 10px;
			line-height: 2;
			background: linear-gradient(90deg, rgb(255 58 54) 0%, rgba(255,119,0,1) 100%);
			color: #fff;
			height: 20px;
		}

		.is-unavailable {
			padding: 4px;
			background: #ff3d3d;
			color: #fff;
			border-radius: 4px;
			font-size: 8px;
			line-height: 10px;
		}
	}
</style>
